import { Controller, useFormContext } from 'react-hook-form';

import type { DateRangePreset } from '~shared/ui/date-picker';
import { DatePicker } from '~shared/ui/date-picker';

import {
  endOfDay,
  startOfDay,
  startOfMonth,
  subMonths,
  subWeeks,
} from 'date-fns';

import type { FiltersValue } from '../filters/filters';

type Props = {
  onFilterChanged: () => void;
};

const periodPresets: DateRangePreset[] = [
  {
    title: 'Last 7 days',
    value: {
      startDate: startOfDay(subWeeks(new Date(), 1)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
  {
    title: 'Last 14 days',
    value: {
      startDate: startOfDay(subWeeks(new Date(), 2)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
  {
    title: 'Last month',
    value: {
      startDate: startOfDay(subMonths(new Date(), 1)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
];

export function PeriodFilter<T>({ onFilterChanged }: Props) {
  const { control } = useFormContext<FiltersValue<T>>();
  const minDate = startOfDay(startOfMonth(subMonths(new Date(), 1)));
  const maxDate = endOfDay(new Date());

  return (
    <Controller
      control={control}
      name="period"
      render={(fp) => (
        <DatePicker
          {...fp}
          minDate={minDate}
          maxDate={maxDate}
          presets={periodPresets}
          onCalendarClose={onFilterChanged}
        />
      )}
    />
  );
}
